<div class="result">
  <div class="result__empty" *ngIf="!isLoading && !questions?.length">
    <div class="result__empty__content">
      <mat-icon class="row__item">search</mat-icon>
      <span class="subtitle-text row__item"> {{ 'DASHBOARD_FORMS.DETAIL.NO_RESULTS' | translate }} </span>
    </div>
  </div>

  <div class="result__card" *ngFor="let question of questions">
    <div class="result__card__header">
      <span class="result__card__header__title">
        <ng-container *ngFor="let icon of questionIcons">
          <mat-icon
            class="result__card__header__title__icon"
            *ngIf="question.type === icon.type"
            [matTooltip]="question.type | formQuestionType"
            [matTooltipPosition]="'left'"
          >
            {{ icon.icon }}
          </mat-icon>
        </ng-container>
        <span class="result__card__header__title__text">{{ question.title }}</span>
      </span>

      <div class="result__card__header__actions">
        <mat-icon
          class="result__card__header__actions__bar"
          matTooltip="{{ 'DASHBOARD_FORMS.DETAIL.TOOLTIP.BAR' | translate }}"
          [matTooltipPosition]="'before'"
          *ngIf="question.chartType == 'bar' || question.chartType == 'pie'"
          [ngClass]="{ 'result__card__header__actions__bar--active': question.chartType == 'bar' }"
          (click)="changeChart(question, 'bar')"
        >
          bar_chart
        </mat-icon>
        <mat-icon
          class="result__card__header__actions__pie"
          matTooltip="{{ 'DASHBOARD_FORMS.DETAIL.TOOLTIP.PIE' | translate }}"
          [matTooltipPosition]="'before'"
          *ngIf="question.chartType == 'bar' || question.chartType == 'pie'"
          [ngClass]="{ 'result__card__header__actions__bar--active': question.chartType == 'pie' }"
          (click)="changeChart(question, 'pie')"
        >
          pie_chart_outline
        </mat-icon>
        <mat-icon
          class="result__card__header__actions__alternative"
          matTooltip="{{ 'DASHBOARD_FORMS.DETAIL.TOOLTIP.INFO' | translate }}"
          [matTooltipPosition]="'before'"
          *ngIf="!isGraph(question.type)"
        >
          info_outline
        </mat-icon>
      </div>
    </div>

    <div class="result__card__content">
      <ng-container *ngIf="question.chartType">
        <div class="result__card__horizontal-chart-container" *ngIf="question.chartType === 'bar'">
          <fc-horizontal-bar-chart
            [results]="question.answers"
            [isLoading]="isLoading"
            [colors]="formsColors"
          ></fc-horizontal-bar-chart>
        </div>
        <pie-chart
          *ngIf="question.chartType === 'pie'"
          [results]="question.answers"
          [isLoading]="isLoading"
          [legendPosition]="'right'"
          [view]="[300, 300]"
        >
        </pie-chart>
      </ng-container>

      <app-alternative-question-chart
        *ngIf="!question.chartType"
        [results]="question"
        [isLoading]="isLoading"
      ></app-alternative-question-chart>
    </div>
  </div>

  <!-- SKELETON-LOADER -->

  <ng-container *ngIf="isLoading">
    <div class="result__card" *ngFor="let question of [0, 1, 2]">
      <div class="result__card__header">
        <span class="result__card__header__title">
          <ngx-skeleton-loader
            appearance="circle"
            [theme]="{ height: '24px', width: '24px', 'margin-bottom': '0px', 'margin-top': '0px' }"
          ></ngx-skeleton-loader>
          <ngx-skeleton-loader
            [theme]="{ height: '24px', width: '100px', 'margin-bottom': '0px', 'margin-top': '0px' }"
          ></ngx-skeleton-loader>
        </span>

        <div class="result__card__header__actions">
          <ngx-skeleton-loader
            appearance="circle"
            [theme]="{ height: '24px', width: '24px', 'margin-bottom': '0px', 'margin-top': '0px' }"
          ></ngx-skeleton-loader>
        </div>
      </div>

      <div class="result__card__content">
        <ngx-skeleton-loader count="5" [theme]="{ height: '24px', 'margin-bottom': '16px' }"></ngx-skeleton-loader>
      </div>
    </div>
  </ng-container>

  <!-- /SKELETON-LOADER -->
</div>
